import { useQuery } from '@tanstack/react-query'
import { MasterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { queryKeys } from './queryKeys'

export const useQueryMaster = (masterUuid: string) => {
  return useQuery({
    queryKey: queryKeys.master(masterUuid),
    queryFn: () => baseClient.getApi(MasterApi).getMaster({ masterUuid }),
    enabled: !!masterUuid,
  })
}
